import Vue from 'vue';
import VueResource from 'vue-resource';
import VueCookies from 'vue-cookies';
import VueContentPlaceholders from 'vue-content-placeholders';
import VuexStore from './configs/vuexstore.js';
import App from './components/App.vue';
import router from './configs/router.js';
import simpleStore from './configs/store.js';
import ErrorMessaging from './configs/error-messaging';
import DyadeyScroll from './configs/dyadey-scroll.js';
import './eventLogger';
import './plugins/fontawesome';

Vue.config.devtools = false;
Vue.config.debug = false;
Vue.config.silent = true;
Vue.prototype.$log = console.log;

Vue.prototype.$simpleStore = simpleStore;
Vue.prototype.$dyadeyScroll = DyadeyScroll;
Vue.prototype.$errorMessaging = ErrorMessaging;
Vue.prototype.$cdn = function(path) {
    return (this.$root.staticUrl || '') + path;
};

Vue.use(VueResource);
Vue.use(VueCookies);
Vue.use(VueContentPlaceholders);

new Vue({
    // make these root variables reactive by declaring them
    data: {
        community: {}
    },
    router,
    store: VuexStore,
    render: h => h(App),
    created() {
        /*let windowVars = ['__VUE_HOT_MAP__','google_tag_manager','google_tag_data','GoogleAnalyticsObject','gaplugins','gaGlobal','gaData','TEMPORARY','PERSISTENT','dataLayer', 'caches','trustedTypes','twemoji','postMessage','blur','focus','close','frames','self','window','parent','opener','top','length','closed','location','document','origin','name','history','locationbar','menubar','personalbar','scrollbars','statusbar','toolbar','status','frameElement','navigator','customElements','external','screen','innerWidth','innerHeight','scrollX','scrollX','scrollY','pageYOffset','screenX','screenY','outerWidth','outerHeight','devicePixelRatio','clientInformation','screenLeft','screenTop','defaultStatus','defaultstatus','styleMedia','onanimationend','onanimationiteration','onanimationstart','onsearch','ontransitionend','onwebkitanimationend','onwebkitanimationiteration','onwebkitanimationstart','onwebkittransitionend','isSecureContext','onabort','onblur','oncancel','oncanplay','oncanplaythrough','onchange','onclick','onclose','oncontextmenu','oncuechange','ondblclick','ondrag','ondragend','ondragenter','ondragleave','ondragover','ondragstart','ondrop','ondurationchange','onemptied','onended','onerror','onfocus','oninput','oninvalid','onkeydown','onkeypress','onkeyup','onload','onloadeddata','onloadedmetadata','onloadstart','onmousedown','onmouseenter','onmouseleave','onmousemove','onmouseout','onmouseover','onmouseup','onmousewheel','onpause','onplay','onplaying','onprogress','onratechange','onreset','onresize','onscroll','onseeked','onseeking','onselect','onstalled','onsubmit','onsuspend','ontimeupdate','ontoggle','onvolumechange','onwaiting','onwheel','onauxclick','ongotpointercapture','onlostpointercapture','onpointerdown','onpointermove','onpointerup','onpointercancel','onpointerover','onpointerout','onpointerenter','onpointerleave','onafterprint','onbeforeprint','onbeforeunload','onhashchange','onlanguagechange','onmessage','onmessageerror','onoffline','ononline','onpagehide','onpageshow','onpopstate','onrejectionhandled','onstorage','onunhandledrejection','onunload','performance','stop','open','alert','confirm','prompt','print','requestAnimationFrame','cancelAnimationFrame','requestIdleCallback','cancelIdleCallback','captureEvents','releaseEvents','getComputedStyle','matchMedia','moveTo','moveBy','resizeTo','resizeBy','getSelection','find','webkitRequestAnimationFrame','webkitCancelAnimationFrame','fetch','btoa','atob','setTimeout','clearTimeout','setInterval','clearInterval','createImageBitmap','scroll','scrollTo','scrollBy','onappinstalled','onbeforeinstallprompt','crypto','ondevicemotion','ondeviceorientation','ondeviceorientationabsolute','indexedDB','webkitStorageInfo','sessionStorage','localStorage','chrome','visualViewport','speechSynthesis','webkitRequestFileSystem','webkitResolveLocalFileSystemURL','addEventListener', 'removeEventListener', 'openDatabase', 'dispatchEvent'];
        for (let i in window) {
            if (windowVars.includes(i) === false && typeof window[i] != 'function' && window[i] != null) {
                this[i] = window[i];
            }
        }*/
        // add appData from layout template to Vue $root data
        this.showContextMenu = false;
        this.showCookiesPanel = false;
        try {
            for (let i in appData) {
                this[i] = appData[i];
            }
            /*this.$castle.configure(496714935486556);
            this.$castle.createRequestToken().then((requestToken) => {
                this.$cookies.config('1h', '/', '', true);
                this.$cookies.set('castle', requestToken);
            });*/
        } catch (Err) {
            console.log(i, Err);
        }
    }
}).$mount('#dyadey');
